import { FC } from 'react';

import { SelectResponse } from '../../../../shared/model/commonModel';

interface DataGridObjectTemplateProps {
  value: SelectResponse;
}

const DataGridObjectTemplate: FC<DataGridObjectTemplateProps> = (props) => {
  if (props.value) {
    return <>{props.value.name}</>;
  }

  return <></>;
};

export default DataGridObjectTemplate;
